<template>
    <v-card-text class="pa-6">
        <div class="text-right pb-3">
            <v-btn
                icon
                color="primary"
                style="height: 20px; width: 20px;"
                @click="close"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </div>

        <v-sheet
            tile
            color="#F8F8F8"
            class="pa-4 mb-5 text-center"
        >
            <h4
                class="title font-weight-bold mb-4"
                style="color: #989898"
            >
                Powered by Plaid
            </h4>
            <v-img
                src="/images/plaid-explainer-icon.png"
                max-width="185"
                class="mx-auto"
                alt="plaid explainer icon"
            />
        </v-sheet>

        <h4 class="title font-weight-bold primary--text text-center">
            How it works
        </h4>
        <v-carousel
            v-model="currentSlide"
            :continuous="false"
            hide-delimiter-background
            height="auto"
            :class="{ 'done': currentSlide === 3 }"
        >
            <template v-slot:prev="{ on, attrs }">
                <v-btn
                    icon
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
            </template>
            <template v-slot:next="{ on, attrs }">
                <v-btn
                    icon
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon>mdi-arrow-right</v-icon>
                </v-btn>
            </template>
            <v-carousel-item
                v-for="(text, i) in explainers"
                :key="i"
                class="my-8"
            >
                <div class="text-center">
                    <h4
                        v-if="i"
                        class="subtitle-1 font-weight-bold"
                        style="color: #1B1A1A"
                    >
                        Step {{ i }}
                    </h4>
                    <p
                        class="subtitle-1"
                        style="color: #1B1A1A"
                    >
                        {{ text }}
                    </p>
                </div>
            </v-carousel-item>
        </v-carousel>

        <div
            v-if="currentSlide === 3"
            class="text-center"
        >
            <v-btn
                class="px-12 text--white text-none"
                color="primary"
                dark
                depressed
                @click.prevent="proceed"
            >
                Proceed
            </v-btn>
        </div>
    </v-card-text>
</template>

<script>
    import explainers from './explainer';

    export default {
        data() {
            return {
                explainers,
                currentSlide: 0,
            };
        },
        methods: {
            proceed() {
                this.currentSlide = 0;
                this.$emit('update:show', false);
            },
            close() {
                this.currentSlide = 0;
                this.$emit('close', false);
            },
        },
    };
</script>

<style scoped>
.v-carousel >>> .v-window-item {
    margin: 0 50px;
}

.v-carousel >>> .v-window__next,
.v-carousel >>> .v-window__prev {
    margin: 0;
    background: transparent !important;
    top: 70px;
}

.v-carousel.done >>> .v-carousel__controls {
    display: none;
}

.v-carousel >>> .v-carousel__controls .v-btn.v-btn--icon,
.v-carousel >>> .v-window__next .v-btn.v-btn--icon,
.v-carousel >>> .v-window__prev .v-btn.v-btn--icon {
    color: #181235;
}

.v-carousel >>> .v-carousel__controls .v-btn.v-btn--icon {
    height: 15px;
    width: 15px;
    color: #181835;
    background: #181835 !important;
}

.v-carousel >>> .v-carousel__controls .v-btn.v-btn--icon.v-item--active {
    background: #fff !important;
    color: #fff;
    border: 2px solid #181235;
}
</style>
